import axios from 'axios';
axios.defaults.withCredentials = true
export const baseURL = process.env.REACT_APP_API_URL
const instance = axios.create({
    withCredentials: true,
    baseURL: baseURL
});

export default instance;
